var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanNavLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 22,
    transform: "matrix(-1 0 0 1 22 22)",
    fill: "#E3E2EB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 18.6154,
    transform: "matrix(-1 0 0 1 22.0008 22.0002)",
    fill: "#18BEB3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5831 12.3448C27.2431 13.0048 27.2431 14.0709 26.5831 14.7309L20.017 21.2971L26.5831 27.8633C27.2431 28.5233 27.2431 29.5894 26.5831 30.2494C25.9231 30.9094 24.857 30.9094 24.197 30.2494L16.4293 22.4817C15.7693 21.8217 15.7693 20.7556 16.4293 20.0956L24.197 12.3279C24.84 11.6848 25.9231 11.6848 26.5831 12.3448Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanNavLeft);
export default __webpack_public_path__ + "static/media/plan-nav-left.a9476989970fac7db30efd88adccc2e3.svg";
export { ForwardRef as ReactComponent };